import React from "react";
import { Link } from "react-router-dom";
import classes from './breadcrumbs.module.scss';

export function Breadcrumbs({
  items,
  separator = <span className={classes["separator"]}>{'>'}</span>
}) {
  return (
    <nav aria-label="Breadcrumb" className={classes["breadcrumb-wrapper"]}>
      <ol className={classes["breadcrumb-list"]}>
        {items.map((item, idx) => {
          const isLast = idx === items.length - 1;

          return (
            <li key={`${item.label}-${idx}`} className={classes["breadcrumb-item"]}>
              {!isLast && item.to ? (
                <Link to={item.to} className={classes["breadcrumb-text"]}>
                  {item.label}
                </Link>
              ) : (
                <span className={classes["breadcrumb-text"]} aria-current={isLast ? "page" : undefined}>{item.label}</span>
              )}

              {!isLast ? separator : null}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}